import VaultHero from './VaultHero.js'
import Background from "./Background";
import CirclesLogo from "./CirclesLogo";
import gsap from "gsap";

export default class World {
    constructor(_options) {
        this.experience = new VaultHero()
        this.config = this.experience.config
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.objects = {}
        this.setHero()
        this.resources.on('groupEnd', (_group) => {
            if (_group.name === 'base') {
                this.init()
            }
        })
    }

    init() {
        this.setBackground()
        this.setCirclesLogo()
        this.showHero();
    }

    setHero() {
        this.hero = document.getElementById('in-the-vault--hero');
        this.contnetLeft = this.hero.querySelector('.left');
    }

    showHero() {
        gsap.to(this.experience.targetElement, {
            duration: 0.3,
            opacity: 1,
            ease: 'power2.inOut'
        });

        gsap.to(this.contnetLeft, {
            duration: 1,
            opacity: 1,
            ease: 'power2.inOut'
        });

        this.time.play()
    }

    setBackground() {
        this.background = new Background()
    }

    setCirclesLogo() {
        this.circlesLogo = new CirclesLogo()
    }

    resize() {
        if (this.background) {
            this.background.resize()
        }

        if (this.circlesLogo) {
            this.circlesLogo.resize()
        }
    }

    breakpointChange() {
        if (this.background) {
            this.background.breakpointChange()
        }

        if (this.circlesLogo) {
            this.circlesLogo.breakpointChange()
        }
    }

    update() {
        if (this.circlesLogo) {
            this.circlesLogo.update()
        }

        if (this.background) {
            this.background.update()
        }
    }
}
